export default __webpack_public_path__ + "static/media/ic_car.941c9b1c.svg";